<script lang="ts">
  import { onMount } from "svelte"
  import ScheduleEventLifecycleTimeline from "../../_shared/_modules/schedule-event-lifecycle-timeline"

  type Props = {
    event: ScheduleEvent
    onshowOverlay?: (() => void) | null
  }

  const { event, onshowOverlay = null }: Props = $props()

  onMount(() => {
    onshowOverlay?.()
  })
</script>

<section class="lifecycle-history">
  <p>
    Hier sehen Sie die vollständige Historie dieses Termins. Die neuesten Ereignisse stehen oben.
  </p>
  <ScheduleEventLifecycleTimeline {event} limit={null} showTitle={false} />
</section>

<style lang="less">
  .lifecycle-history {
    --overlay-text-color: var(--text-100);

    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: min(44rem, 80vw);
    color: var(--overlay-text-color);
  }

  .lifecycle-history p {
    max-width: 42rem;
    margin: 0;
    color: color-mix(in srgb, var(--overlay-text-color) 72%, transparent);
    line-height: 1.4;
  }
</style>
